function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__a",
  x1: -0.238,
  y1: -0.358,
  x2: 1.254,
  y2: -0.347,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#f9ad41"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ff4f5f"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5024"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5022",
  fill: "#242752"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2237",
  d: "M185.726 90.689v-6.195h7.774v6.195zm.119 35.653V95.891h7.6v30.451z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2238",
  d: "M211.443 126.341c-6.2 0-8.824-4.384-8.824-8.709v-15.079h-3.217v-5.786h3.216v-9h7.6v9h5.375v5.786h-5.375v14.612c0 1.752.818 2.747 2.629 2.747h2.746v6.429z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2239",
  d: "M221.671 113.193v-7.072h18v7.072z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2240",
  d: "M257.382 126.693c-4.794 0-9.119-.526-12.976-4.383l4.968-4.968c2.513 2.514 5.785 2.865 8.125 2.865 2.63 0 5.376-.877 5.376-3.156 0-1.521-.818-2.573-3.215-2.806l-4.792-.467c-5.494-.527-8.883-2.923-8.883-8.534 0-6.312 5.553-9.7 11.748-9.7 4.733 0 8.707.819 11.627 3.565l-4.674 4.735c-1.753-1.578-4.441-2.046-7.072-2.046-3.038 0-4.325 1.4-4.325 2.922 0 1.111.468 2.4 3.157 2.631l4.792.468c6.018.584 9.06 3.8 9.06 8.942 0 6.718-5.729 9.932-12.916 9.932z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2241",
  d: "M274.571 126.342v-5.786l13.5-17.826h-12.745v-6.839h22.445v5.787l-13.678 17.826h13.678v6.838z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2242",
  d: "M322.902 126.342l-7.481-12.683-3.215 3.624v9.059h-7.6V84.727h7.6v23.613l10.112-12.449h9.176l-10.873 12.273 11.689 18.178z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2243",
  d: "M357.913 122.949a12.62 12.62 0 01-9.468 3.741 12.48 12.48 0 01-9.409-3.741c-2.746-2.863-3.45-6.313-3.45-11.865 0-5.493.7-8.942 3.45-11.805a12.478 12.478 0 019.409-3.741 12.618 12.618 0 019.468 3.741c2.747 2.863 3.45 6.312 3.45 11.805-.001 5.556-.704 9.005-3.45 11.865zm-5.9-19.228a4.8 4.8 0 00-3.566-1.345 4.66 4.66 0 00-3.506 1.345c-1.575 1.577-1.753 4.208-1.753 7.363s.178 5.846 1.753 7.424a4.667 4.667 0 003.506 1.344 4.807 4.807 0 003.566-1.344c1.576-1.578 1.754-4.268 1.754-7.424s-.181-5.783-1.757-7.36z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2244",
  d: "M378.08 126.342c-6.254 0-8.824-4.383-8.824-8.708v-8.944l-3.16 1.93v-6.372l3.16-1.987V84.727h7.592v12.976l3.513-2.164v6.371l-3.513 2.221v13.033c0 1.812.706 2.748 2.635 2.748h2.922v6.429z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2245",
  d: "M403.855 126.343v-2.631c-2.047 2.045-3.974 2.922-7.482 2.922-3.448 0-5.962-.877-7.772-2.688a9.758 9.758 0 01-2.513-6.838c0-4.852 3.333-8.826 10.4-8.826h7.188v-1.519c0-3.332-1.635-4.793-5.67-4.793-2.923 0-4.265.7-5.843 2.514l-4.85-4.735c2.982-3.273 5.905-4.208 10.989-4.208 8.534 0 12.974 3.624 12.974 10.755v20.048zm-.175-12.859h-6.019c-2.749 0-4.27 1.287-4.27 3.449 0 2.1 1.406 3.506 4.387 3.506 2.1 0 3.447-.175 4.791-1.461.822-.759 1.111-1.987 1.111-3.857z"
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 649",
  d: "M351.498 24.686v10.47c0 4.64-3.292 6.728-7.634 6.728h-30.06v5.235c0 7.632 6.434 11.222 12.4 11.52a9.217 9.217 0 008.978-4.787c4.935-8.827 17.946-.3 12.265 7.776-5.234 7.341-13.015 10.171-22.587 10.171-14.66 0-26.476-10.318-26.476-24.681V24.387c0-14.062 11.965-24.384 26.628-24.384s26.486 10.328 26.486 24.686m-37.7 4.936h22.437V24.39a11.223 11.223 0 00-22.437 0z",
  fill: "#24284f"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 650",
  d: "M181.104 46.975V24.838c0-14.211 11.816-24.835 26.628-24.835 14.662 0 26.475 10.632 26.475 24.835v22.137c0 14.36-11.817 24.83-26.475 24.83-14.809 0-26.628-10.47-26.628-24.83m15.26-22.137v22.137a10.927 10.927 0 0010.774 11.08c.2 0 .4 0 .595-.008a10.8 10.8 0 0011.213-10.374c.008-.232.01-.465 0-.7V24.838a11.235 11.235 0 00-11.1-11.368h-.111a11.364 11.364 0 00-11.369 11.358v.01",
  fill: "#24284f"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 651",
  d: "M241.591 57.746c-4.338-8.078 9.424-14.062 13.461-5.984 2.531 5.822 7.78 7.627 13.461 7.627 5.824 0 9.424-3.44 9.424-8.227 0-8.078-16.6-9.72-22.885-12.864-5.533-2.694-13.016-7.627-13.016-18.251 0-11.366 10.47-20.046 24.385-20.046 10.171 0 18.7 3.741 22.735 11.067 5.986 10.92-10.021 16.3-12.564 7.341-1.194-4.05-5.085-5.389-10.171-5.389-3.741 0-9.576 1.5-9.576 7.03 0 2.395 1.047 4.339 4.785 6.131 11.669 5.387 31.718 7.625 31.718 24.98 0 13.923-12.118 21.243-24.381 21.243-13.164 0-21.99-3.29-27.379-14.657",
  fill: "#24284f"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 287"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 652",
  d: "M241.937 234.212a2.75 2.75 0 013.974 2.457v31.594c0 6.48-24.887 19.233-49.784 19.233s-49.812-12.842-49.812-19.233v-31.616a2.749 2.749 0 013.973-2.457l35.112 17.551a27.005 27.005 0 0021.463 0z",
  transform: "translate(-122.8 -168.711)",
  fill: "url(#prefix__a)"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 653",
  d: "M327.214 244.593v-27.342l-8.792 4.4v22.968a6.8 6.8 0 109.582.79 6.941 6.941 0 00-.789-.79z",
  transform: "translate(-186.127 -162.498)",
  fill: "url(#prefix__a)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 286"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 654",
  d: "M182.127 133.733a24.716 24.716 0 00-10.737 2.2l-58.142 29.062c-5.928 2.968-5.928 7.782 0 10.744L171.39 204.8a26.918 26.918 0 0021.463 0L251 175.736c5.929-2.968 5.929-7.781 0-10.744l-58.114-29.062a24.83 24.83 0 00-10.754-2.2",
  transform: "translate(-108.802 -131.329)",
  fill: "url(#prefix__a)"
}))));

function SvgOseItszkola(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 411.277,
    height: 126.693,
    viewBox: "0 0 411.277 126.693",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOseItszkola);
export default __webpack_public_path__ + "static/media/ose-itszkola.3c1679a4.svg";
export { ForwardRef as ReactComponent };